export default __webpack_public_path__ + "static/media/hashtag.d7a8b605.svg";